module.exports = __webpack_public_path__ + "img/mita_no.ab581dcc.png";